<template>
  <span>
    <i :class="classes"></i>
    {{ $t("enum.blocked[" + blocked + "]") }}
  </span>
</template>

<script>
export default {
  props: {
    blocked: {
      type: [Number, String],
      default: "0",
    },
  },
  computed: {
    classes() {
      return ["tg-icon-status", { "is-blocked": this.blocked == 1 }];
    },
  },
};
</script>
